import { RootState } from "store/store";

export const selectLoadingID = (state: RootState) =>
  state.placesUpload.loadingID;

export const selectUploadedIds = (state: RootState) =>
  state.placesUpload.uploadedIDs;

export const selectLocalFiles = (state: RootState) => state.placesUpload.files;

export const selectCountByCategories =
  (fileID: string) => (state: RootState) => {
    return state.placesUpload.groupedByCategories[fileID] ?? {};
  };

export const selectCountedIds = (state: RootState) =>
  state.placesUpload.countedIDs;
